export type LinkBroken01IconProps = {
  className?: string;
  pathClassName?: string;
};

export const LinkBroken01Icon = ({
  className,
  pathClassName,
}: LinkBroken01IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_3290_3399)">
      <path
        d="M7.49984 3.33334V1.66667M12.4998 16.6667V18.3333M3.33317 7.50001H1.6665M16.6665 12.5H18.3332M4.09502 4.09518L2.9165 2.91667M15.9047 15.9048L17.0832 17.0833M9.99984 14.714L8.23207 16.4818C6.93032 17.7836 4.81977 17.7836 3.51802 16.4818C2.21628 15.1801 2.21628 13.0695 3.51802 11.7678L5.28579 10M14.7139 10L16.4817 8.23224C17.7834 6.93049 17.7834 4.81994 16.4817 3.51819C15.1799 2.21645 13.0694 2.21645 11.7676 3.51819L9.99984 5.28596"
        stroke="#D92D20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </g>
    <defs>
      <clipPath id="clip0_3290_3399">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
